import { render, staticRenderFns } from "./szhimg.vue?vue&type=template&id=70ecdf0e&scoped=true&"
import script from "./szhimg.vue?vue&type=script&lang=js&"
export * from "./szhimg.vue?vue&type=script&lang=js&"
import style0 from "./szhimg.vue?vue&type=style&index=0&id=70ecdf0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecdf0e",
  null
  
)

export default component.exports